module.exports = __webpack_public_path__ + "static/media/eventHeader.decb51f1.png";